import PublicLayout1 from './PublicLayout';

export default PublicLayout1;
